import React, { useLayoutEffect } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const InvestorHomePage = React.lazy(() => import('../pages/home'));
const InvestorProfilePage = React.lazy(() => import('../pages/InvestorProfile/InvestorProfilePage'));
const LoginPage = React.lazy(() => import('../pages/LoginPage'));
const RegisterPage = React.lazy(() => import('../pages/RegisterPage'));
const ForgotPasswordPage = React.lazy(() => import('../pages/ForgotPasswordPage'));

type Props = {
  children: React.ReactElement;
};

function PrivateRoute({ children }: Props) {
  const authState = useSelector((state: RootState) => state.auth);
  const cookieMatch = document.cookie.match(/(?:^|; )investor_token=([^;]*)/) || document.cookie.match(/(?:^|; )public_private_token=([^;]*)/);
  const cookieToken = cookieMatch ? decodeURIComponent(cookieMatch[1]) : null;
  const token = cookieToken || localStorage.getItem('investor_token') || localStorage.getItem('public_private_token') || sessionStorage.getItem('investor_token') || sessionStorage.getItem('public_private_token');

  const isLoggedIn = Boolean(token && token !== 'null' && token !== 'undefined' && token !== 'false') || authState.isAuthenticated;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default function Router(): React.ReactElement {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scroll(0, 0);
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/" element={<InvestorHomePage />} />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <InvestorProfilePage />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
